import React from "react";
import { DataTable } from "react-native-paper";
import { TableValueCellComponent } from "./Types";
import { useAppSelector } from "../../redux/store";

export const TableSelectionCell: TableValueCellComponent = ({
  field,
  value,
  t,
}) => {
  const userRole = useAppSelector((state) => state.auth.user.role);
  const normalizedValue =
    Array.isArray(field.options) &&
    value !== null &&
    typeof value !== "undefined" &&
    !field.options.includes(value)
      ? field.defaultValue
      : value;
  const roleHiddenValues = field.hideWhenValueInDisplayByRole?.[userRole] ?? [];
  const shouldHideByValue = [...(field.hideWhenValueInDisplay ?? []), ...roleHiddenValues]
    .map((hiddenValue) => String(hiddenValue))
    .includes(String(normalizedValue));

  return (
    <DataTable.Cell style={{ flex: field.width || 1 }}>
      {shouldHideByValue
        ? ""
        : Array.isArray(normalizedValue)
        ? normalizedValue.map((v) => t(v)).join(", ")
        : t(normalizedValue)}
    </DataTable.Cell>
  );
};
